// slider-script.js
$(document).ready(function() {
  let currentPage = 0;
  const sliderPages = $('.slider-page');

function showPage(pageIndex) {
  const sliderWidth = sliderPages.parent().width(); // Get the width of the slider container

  sliderPages.each(function(index, page) {
    const slideWidth = $(page).outerWidth(); // Get the width of each slide, including margins
    const slidePosition = (index - pageIndex) * slideWidth; // Calculate the position of the slide

    $(page).css('transform', `translateX(${slidePosition}px)`); // Move the slide
  });
}


  // Next button click event
  $('.next-button').click(function() {
    if (currentPage < sliderPages.length - 1) {
      currentPage++;
      showPage(currentPage);
    }
  });

  // Previous button click event
  $('.prev-button').click(function() {
    if (currentPage > 0) {
      currentPage--;
      showPage(currentPage);
    }
  });
});
